import React from 'react'

import { LntIconButton } from '@app/components/base'
import { Icon } from '@app/components/util'

import variables from '@app/theme/variables'

import { BUTTON_TYPE, SIZE } from '@app/constants'
import { ICON_NAME } from '@app/constants/icon'

import type { TableSearchButtonProps } from './types'

export const TableSearchButton: React.FC<TableSearchButtonProps> = ({ active, ...restProps }) => {
  const textColor = active ? variables.brandBlue : undefined

  return (
    <LntIconButton
      { ...restProps }
      textColor={ textColor }
      type={ BUTTON_TYPE.text }
      size={ SIZE.small }
      icon={ <Icon name={ ICON_NAME.search } /> }
    />
  )
}
